import React from 'react';
import styles from './InsuranceDevice.module.css';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import * as routes from 'app/routes';

import DeviceSelector from 'devices/DeviceSelector';
import Back from 'common/Back';

const bypassedInsuranceDevice = ({ subId }) => (
  <div className={styles.InsuranceDevice}>
    <SubscriptionSwitcher
      bypassedSubId={subId}
      quickRoute={routes.quickSubscription}
      bypassedRoute={routes.bypassedSubscription}
      sprintRoute={routes.sprintSubscription} 
    />
    <div className={styles.Back}>
      <Back to={routes.bypassedSubscription(subId)} />
    </div>
    <h1>
      Device Protection
    </h1>
    <DeviceSelector subId={subId} next={routes.bypassedInsurancePlan} />
  </div>
)

export default bypassedInsuranceDevice;
